import React from "react";
import { getColor } from "utils/common";

const CustomBatch = ({
    className,
    color,
    value = "Default Value",
}) => {

    return (
        <div className={`border-round p-2 text-center text-white w-7 ${className}`} style={{ "background": `${color || getColor(value)}` }}>{value}</div>
    )
}

export default CustomBatch